import { render } from "./EducationModal.vue?vue&type=template&id=28fd7c20&scoped=true"
import script from "./EducationModal.vue?vue&type=script&lang=js"
export * from "./EducationModal.vue?vue&type=script&lang=js"

import "./EducationModal.vue?vue&type=style&index=0&id=28fd7c20&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fd7c20"]])

export default __exports__